import {Vehicle} from "./vehicle";
import {ProcedureType} from "./procedureType";
import {ExpirationType} from "./expirationType";
import {ProcedureDocument} from "./ProcedureDocument";
import {AddPatentPayment} from "./AddPatentPayment";

export class Procedure {
    public id: string;
    public tempId: string;
    public creationDate: string;
    public type: ProcedureType = new ProcedureType(null);
    public expirationType: ExpirationType;
    public customDate: string;

    public expirationDateSince: string;
    public expirationDateUntil: string;

    public description: string;
    public comment: string;
    public done: boolean;

    public patentPayment: AddPatentPayment = new AddPatentPayment(null);

    public vehicle: Vehicle;

    public document: ProcedureDocument;

    public sent:boolean = false;
    public withSendMail:boolean = false;

    constructor(other ?: Procedure) {
        if (other) {
            this.id = other.id;
            this.tempId = other.tempId;
            this.creationDate = other.creationDate;
            this.type = new ProcedureType(other.type);
            this.expirationType = other.expirationType;
            this.customDate = other.customDate;

            this.expirationDateSince = other.expirationDateSince;
            this.expirationDateUntil = other.expirationDateUntil;

            this.description = other.description;
            this.comment = other.comment;
            this.done = other.done;

            this.patentPayment = new AddPatentPayment(other.patentPayment);

            this.vehicle = other.vehicle;

            this.document = new ProcedureDocument(other.document);

            this.withSendMail = other.withSendMail;
            this.sent = other.sent;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/procedure.ts
 **/